import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

export default function AuthGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isInitialized && !isLoggedIn && location.pathname !== '/login') {
      navigate('/login', {
        state: { from: location.pathname },
        replace: true
      });
    }
  }, [isLoggedIn, isInitialized, navigate, location.pathname]);

  if (!isInitialized) return <Loader />;
  if (!isLoggedIn) return <Loader />;

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
